import { trim, replace } from 'lodash'

export function html2Text(html: string): string {
  return trim(replace(html, /<[^>]*(>|$)| |‌|»|«|>/g, ' ').replace(/\s+/g, ' '))
}
